/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { t } from 'utils/translates';
import UserDaysStatTable2 from './../../../../../../components/UserDaysStat/UserDaysStatTables/UserDaysStatTable2';

class UserReferralsDayStat extends Component {
  render() {
    return (
      <React.Fragment>
        <div
          className="panel panel-default panel-heading_padding-large"
          id="statAffiliateMoney"
        >
          <div className="panel-heading text-center">
            <h2 className="panel-title">
              <i className="fa fa-bar-chart fa-lg" /> {t('Статистика')}
            </h2>
          </div>
          <div className="panel-body">
            <UserDaysStatTable2 {...this.props} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(UserReferralsDayStat);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/ReferralProgram/ReferralMyStat/UserReferralsDayStat/UserReferralsDayStat.js